import React, { Component } from 'react';
import { connect } from 'react-redux';

import DashboardAttributes from './DashboardAttributes';
import DashboardProducts from './DashboardProducts';

import sectionStyles from './_styles/ManageSection.module.scss';
import styles from './_styles/ManageDashboard.module.scss';

const allActionCreators = Object.assign({});

export class ManageDashboard extends Component {

	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {

		return <div className={`${styles.ManageDashboard} ${sectionStyles.ManageSection}`}>
			<div className={sectionStyles.sectionTitle}>DDNY Dashboard</div>
			<div className={sectionStyles.sectionBody}>
				<div className={styles.componentWrapper}>
					<DashboardProducts />
				</div>
				<div className={styles.componentWrapper}>
					<DashboardAttributes />
				</div>
			</div>
		</div>;
	}
}

function mapStateToProps(state) {
	return {

	};
}

export default connect(mapStateToProps, allActionCreators)(ManageDashboard);